/**
 * @generated SignedSource<<e09edd0df18cb92b8db97ff49029a044>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_displayInfo" | "PdpRespSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo">;
  readonly " $fragmentType": "PdpRespContainer_displayInfo";
};
export type PdpRespContainer_displayInfo$key = {
  readonly " $data"?: PdpRespContainer_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo"
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "9cf5b6e7673821af071a2e5728016e6f";

export default node;
